import React from 'react'
import { usePage } from '@/hooks'
import { IObjectPage } from '@/interfaces/ObjectPage'
import { Helmet } from 'react-helmet-async'

const BaseLayout = ({ children }): React.ReactElement => {
  const page = usePage()

  const { object } = page?.init_state
  const {
    seo_title: seoTitle = '',
    title,
    seo_description: seoDescription,
    description,
    seo_keywords: seoKeywords,
    seo_image: seoImage,
    seo_author: seoAuthor = '',
    seo_og_type: seoOgType
  } = object as IObjectPage
  const currentTitle = seoTitle === '' ? title : seoTitle
  return (
    <>
      <Helmet>
        <title>{currentTitle ?? 'Игра ЖЭКА'} | Первый обучающий комплекс по ЖКХ</title>
        <meta
          name='description'
          content={seoDescription ?? description ?? ''}
        />
        <meta name='keywords' content={seoKeywords} />
        <meta property='og:description' content={seoDescription} />
        {seoImage !== null
          ? (
            <meta property='og:image' content={seoImage} />
            )
          : (
              ''
            )}
        <meta property='og:title' content={seoTitle ?? title} />
        <meta property='og:type' content={seoOgType ?? 'website'} />
        <meta property='og:article:author' content={seoAuthor} />
      </Helmet>
      {children}
    </>
  )
}

export default BaseLayout
